(() => {
  if (window.AlawooderJournalTables) {
    window.AlawooderJournalTables.init(document);
    return;
  }

  const instances = new Map();
  const selector = '.ah-journal[data-journal-section]';
  const restore = (element, name, value) => value === null ? element.removeAttribute(name) : element.setAttribute(name, value);

  function mount(section) {
    if (instances.has(section)) return;
    const body = section.querySelector('.ah-article-body');
    const tables = Array.from(body?.querySelectorAll('table') || []);
    if (!tables.length) return;
    const items = tables.map((table, index) => {
      const hint = document.createElement('p');
      hint.className = 'ah-article-table-hint';
      hint.id = `JournalTableHint-${section.dataset.journalSection}-${index}`;
      hint.textContent = section.dataset.journalTableHint;
      hint.hidden = true;
      table.before(hint);
      return { table, hint, tabindex: table.getAttribute('tabindex'), description: table.getAttribute('aria-describedby') };
    });
    let frame = 0;
    const update = () => {
      frame = 0;
      items.forEach(({ table, hint, tabindex, description }) => {
        const overflow = table.clientWidth > 0 && table.scrollWidth > table.clientWidth + 1;
        hint.hidden = !overflow;
        table.toggleAttribute('data-journal-table-overflow', overflow);
        if (overflow) {
          table.setAttribute('tabindex', '0');
          table.setAttribute('aria-describedby', [description, hint.id].filter(Boolean).join(' '));
        } else {
          restore(table, 'tabindex', tabindex);
          restore(table, 'aria-describedby', description);
        }
      });
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    observer?.observe(body);
    tables.forEach(table => observer?.observe(table));
    window.addEventListener('resize', schedule, { passive: true });
    body.addEventListener('load', schedule, true);
    document.fonts?.ready.then(() => { if (instances.has(section)) schedule(); });
    instances.set(section, () => {
      cancelAnimationFrame(frame);
      observer?.disconnect();
      window.removeEventListener('resize', schedule);
      body.removeEventListener('load', schedule, true);
      items.forEach(({ table, hint, tabindex, description }) => {
        hint.remove();
        table.removeAttribute('data-journal-table-overflow');
        restore(table, 'tabindex', tabindex);
        restore(table, 'aria-describedby', description);
      });
    });
    update();
  }

  function mountTopics(section) {
    if (instances.has(section)) return;
    const track = section.querySelector('.ah-journal-topic-links');
    if (!track) return;
    let frame = 0;
    const update = () => {
      frame = 0;
      const active = track.querySelector('[aria-current="page"]');
      if (!active || track.scrollWidth <= track.clientWidth + 1) return;
      const left = active.getBoundingClientRect().left - track.getBoundingClientRect().left + track.scrollLeft;
      const right = left + active.getBoundingClientRect().width;
      const max = track.scrollWidth - track.clientWidth;
      if (left < track.scrollLeft + 8) track.scrollLeft = Math.max(0, left - 8);
      else if (right > track.scrollLeft + track.clientWidth - 10) track.scrollLeft = Math.min(max, right - track.clientWidth + 10);
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
    const observer = typeof ResizeObserver === 'function' ? new ResizeObserver(schedule) : null;
    observer?.observe(track);
    window.addEventListener('resize', schedule, { passive: true });
    document.fonts?.ready.then(() => { if (instances.has(section)) schedule(); });
    instances.set(section, () => {
      cancelAnimationFrame(frame);
      observer?.disconnect();
      window.removeEventListener('resize', schedule);
    });
    update();
  }

  function init(root) {
    const sections = Array.from(root.querySelectorAll(selector));
    if (root.matches?.(selector)) sections.unshift(root);
    sections.forEach(section => { mount(section); mountTopics(section); });
  }
  window.AlawooderJournalTables = { init };
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => {
    instances.forEach((cleanup, section) => {
      if (event.target === section || event.target.contains(section)) {
        cleanup();
        instances.delete(section);
      }
    });
  });
  init(document);
})();
